import { mapState, mapGetters } from 'vuex';
export default {
  name: 'CoreMainAuthInclude',
  data: function () {
    return {
      host: window.location.hostname
    };
  },
  computed: {
    ...mapState('authentication', ['token']),
    ...mapGetters({
      userId: 'authentication/userId'
    }),
    iframeSrc() {
      return `${process.env.VUE_APP_MAIN_UI_PROTOCOL}://${process.env.VUE_APP_MAIN_UI_HOST}/mainAuthInclude.html#host=${this.host}`;
    }
  }
};